import { CltTable } from "@/app/contexts/SelfHiringContext"
import { httpClient } from "../http/httpClient"

export interface SimulateCltParams {
  linkName: string
  birthDate?: string
  matricula?: string
  prazo?: number
  quantidadeParcelas?: number
  valorFinanciado?: number
}

export interface SimulateCltResponse {
  available: boolean
  matriculas?: unknown[]
  prazos?: number[]
  tables?: CltTable[]
  matricula?: string
  cnpjEmpresa?: string
}

export async function simulateClt(
  cpf: string,
  params: SimulateCltParams,
): Promise<SimulateCltResponse> {
  const { linkName, birthDate, ...providerData } = params

  const { data } = await httpClient
    .patch<SimulateCltResponse>(`/self-hire/${linkName}/simulate`, {
      type: "CLT",
      cpf,
      birthDate,
      providerData,
    })
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
